var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 7",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 0.814333C11.0007 1.01629 10.9256 1.21824 10.7755 1.37622L6.12903 6.24756C5.97562 6.40717 5.76346 6.5 5.5415 6.5C5.31954 6.5 5.10737 6.41205 4.95233 6.25407L0.232447 1.41368C-0.0825376 1.09121 -0.0743774 0.576549 0.248768 0.262217C0.571913 -0.052115 1.08764 -0.0439721 1.40263 0.278503L5.53171 4.5114L9.59387 0.252444C9.90396 -0.0732884 10.4213 -0.0863175 10.7477 0.224757C10.9158 0.384367 11.0007 0.59935 11.0007 0.814333Z",
    fill: "#908F94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.5,
    height: 11,
    fill: "white",
    transform: "translate(2.84124e-07 6.5) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.d5a3fe8055edac9e7a6d0fec30dc9ba3.svg";
export { ForwardRef as ReactComponent };